export default __webpack_public_path__ + "static/media/virus.07755bb6.svg";